<li class="nav-item navbar-dropdown dropdown-user dropdown">
  <a class="nav-link dropdown-toggle hide-arrow" href="javascript:void(0);" data-bs-toggle="dropdown">
    <div class="avatar avatar-online">
      <img src="../assets/img/logo/logo.png" alt class="w-px-40 h-auto rounded-circle" />
    </div>
  </a>
  <ul class="dropdown-menu dropdown-menu-end">
    <li>
      <a class="dropdown-item">
        <div class="d-flex">
          <div class="flex-shrink-0 me-3">
            <div class="avatar avatar-online">
              <img src="assets/img/logo/logo.png" alt class="w-px-40 h-auto rounded-circle" />
            </div>
          </div>
          <div class="flex-grow-1">
            <span class="fw-semibold d-block">{{ name }}</span>
            <small class="text-muted">{{ contractor }}</small>
          </div>
        </div>
      </a>
    </li>
    <li>
      <div class="dropdown-divider"></div>
    </li>
    <!-- <li>
      <a class="dropdown-item" href="#">
        <i class="bx bx-user me-2"></i>
        <span class="align-middle">Mi Perfil</span>
      </a>
    </li>-->
    <li>
      <a class="dropdown-item pointer" (click)="navigate('/home/mi-perfil')">
        <i class="pi pi-user me-2"></i>
        <span class="align-middle">Mi perfil</span>
      </a>
    </li>
    <!-- <li *permission="['admin_options']">
      <a class="dropdown-item pointer" (click)="navigate('/home/settings')">
        <i class="bx bx-cog me-2"></i>
        <span class="align-middle">Administración</span>
      </a>
    </li> -->
    <li *permission="['admin']">
      <a class="dropdown-item pointer" (click)="navigate('/home/settings-shell')">
        <i class="bx bx-cog me-2"></i>
        <span class="align-middle">Administración Shell</span>
      </a>
    </li>
    <li>
      <a class="dropdown-item pointer" (click)="cambiarSistema()">
        <i class="pi pi-replay" style="font-size: .8rem"></i> Cambiar Sistema
      </a>
    </li>

    <!--
    <li>
      <a class="dropdown-item" href="#">
        <span class="d-flex align-items-center align-middle">
          <i class="flex-shrink-0 bx bx-credit-card me-2"></i>
          <span class="flex-grow-1 align-middle">Billing</span>
          <span
            class="flex-shrink-0 badge badge-center rounded-pill bg-danger w-px-20 h-px-20"
            >4</span
          >
        </span>
      </a>
    </li>
    <li>
      <div class="dropdown-divider"></div>
    </li> -->
    <li (click)="logout()">
      <a class="dropdown-item pointer">
        <i class="bx bx-power-off me-2"></i>
        <span class="align-middle">Salir</span>
      </a>
    </li>
  </ul>
</li>